export enum PatientsRoutesEnum {
  LIST = '',
  DETAILS = 'details',
}
